import React from "react";

import ChatHeader from './ChatHeader';
import ChatContent from './ChatContent';
import MoreButon from './MoreButon';

export default (props) => {

    const {messages, toggle, toggleChatContent, loadMoreMessage} = props;
    let nextPage = messages ? messages.next : null

    return (
        <div className="dialog toggle-dialog">
            <ChatHeader
                messages={messages}
                toggle={toggle}
                toggleChatContent={toggleChatContent}
                /> 
            
            <ChatContent
                messages={messages}
                toggle={toggle}
                />
            
            {
                !toggle && nextPage ?
                <MoreButon loadMoreMessage={loadMoreMessage} />
                : null
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Chat/Dialog.js